// extracted by mini-css-extract-plugin
module.exports = {"rectBackground":"ypgpYM5a","verticalBarRoot":"_1PlGuXzk"};